'use strict';

var CONSTANTS = {
    MESSAGE_TIMEOUT: 5000,
    PAGINATION_DELAY: 100,
    PRODUCTS_PER_PAGE: 12,
    PAGE_RANGE: 2,
    SCROLL_DURATION: 300
};

/**
 * Display success or error message after wishlist action
 * @param {Object} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status = data.success ? 'alert-success' : 'alert-danger';

    if ($('.add-to-wishlist-messages').length === 0) {
        $('body').append(
            '<div class="add-to-wishlist-messages "></div>'
        );
    }

    $('.add-to-wishlist-messages')
        .append('<div class="add-to-wishlist-alert text-center ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.add-to-wishlist-messages').remove();
        button.removeAttr('disabled');
    }, CONSTANTS.MESSAGE_TIMEOUT);
}

/**
 * Toggle visibility of add/remove wishlist buttons
 * @param {Object} button - the button that was clicked
 * @param {boolean} isAdded - whether item was added (true) or removed (false)
 */
function toggleWishlistButtons(button, isAdded) {
    if (isAdded) {
        button.addClass('d-none');
        button.siblings('.js-tile-wishlistRemove-btn').removeClass('d-none');
    } else {
        button.addClass('d-none');
        button.siblings('.js-tile-wishlist-btn').removeClass('d-none');
    }
}

/**
 * Perform sort AJAX request and update grid
 * @param {string} url - sort URL
 * @param {Object} triggerElement - element that triggered the sort
 */
function performSort(url, triggerElement) {
    $.spinner().start();
    $(triggerElement).trigger('wishlist:sort', url);

    $.ajax({
        url: url,
        data: { selectedUrl: url },
        method: 'GET',
        success: function (response) {
            $('.cc-plp__product-grid').empty().html(response);
            $('body').trigger('search:updateDom', '.cc-plp__product-grid');

            setTimeout(function () {
                if (window.initWishlistPagination) {
                    window.initWishlistPagination();
                }
            }, CONSTANTS.PAGINATION_DELAY);

            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Get URL parameter by name
 * @param {string} name - parameter name
 * @returns {string|null} parameter value
 */
function getParameterByName(name) {
    var url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    var results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/**
 * Generate pagination page numbers array with ellipsis
 * @param {number} currentPage - current active page
 * @param {number} totalPages - total number of pages
 * @param {number} pageRange - range of pages to show around current
 * @returns {Array} array of page numbers and ellipsis
 */
function generatePagesArray(currentPage, totalPages, pageRange) {
    var pagesArray = [];

    if (totalPages <= 5 + pageRange * 2) {
        for (var i = 1; i <= totalPages; i++) pagesArray.push(i);
    } else {
        pagesArray.push(1);
        var start = Math.max(2, currentPage - pageRange);
        var end = Math.min(totalPages - 1, currentPage + pageRange);

        if (start > 2) pagesArray.push('...');
        for (var i = start; i <= end; i++) pagesArray.push(i);
        if (end < totalPages - 1) pagesArray.push('...');
        pagesArray.push(totalPages);
    }

    return pagesArray;
}

module.exports = {
    addToWishlist: function () {
        $('body').off('click.addWishlist').on('click.addWishlist', '.js-tile-wishlist-btn', function (e) {
            e.preventDefault();
            var url = $(this).data('href');
            var button = $(this);
            var pid = $(this).closest('.js-prod-tile').data('pid') || $(this).closest('.cc-pdp').data('pid');
            var optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
            var optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
            optionId = optionId || null;
            optionVal = optionVal || null;
            if (!url || !pid) {
                return;
            }

            $.spinner().start();
            $(this).attr('disabled', true);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: {
                    pid: pid,
                    optionId: optionId,
                    optionVal: optionVal
                },
                success: function (data) {
                    displayMessage(data, button);
                    toggleWishlistButtons(button, true);
                },
                error: function (err) {
                    displayMessage(err, button);
                    toggleWishlistButtons(button, false);
                }
            });
        });
    },

    removeFromWishlist: function () {
        $('body').off('click.removeWishlist').on('click.removeWishlist', '.js-tile-wishlistRemove-btn', function (e) {
            e.preventDefault();
            var button = $(this);
            var url = $(this).data('href');
            var pid = $(this).closest('.js-prod-tile').data('pid') || $(this).closest('.cc-pdp').data('pid');
            var tileWrapper = button.closest('.js-prod-tile__wrapper');
            var tileWrapperParent = tileWrapper.parent();
            var tileWrapperNext = tileWrapper.next();

            $.spinner().start();
            $(this).attr('disabled', true);
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                data: {
                    pid: pid,
                },
                success: function (data) {
                    displayMessage(data, button);
                    toggleWishlistButtons(button, false);

                    if ($('.page').data('action') === 'Wishlist-Show') {
                        tileWrapper.detach();

                        if (data.listIsEmpty) {
                            sessionStorage.setItem('scrollToHeaderAfterReload', 'true');
                        }
                        $.spinner().start();
                        window.location.reload();
                    }
                },
                error: function (err) {
                    displayMessage(err, button);
                    toggleWishlistButtons(button, true);

                    if ($('.page').data('action') === 'Wishlist-Show') {
                        if (tileWrapperNext.length) {
                            tileWrapperNext.before(tileWrapper);
                        } else {
                            tileWrapperParent.append(tileWrapper);
                        }
                    }
                }
            });
        });
    },

    sort: function () {
        // Handle desktop sort order menu selection
        $('.js-wishlistShow').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();
            performSort(this.value, this);
        });

        // Handle mobile sort apply button
        $('.js-wishlistShow').on('click', '.js-sort-mobile-apply', function (e) {
            e.preventDefault();
            var sortUrl = $(this).closest('.js-sort-mobile').find('.js-sort-mobile-input:checked').attr('data-value');
            performSort(sortUrl, this);
        });
    }
};

$(() => {
    // Handle scroll after page reload from wishlist removal
    if (sessionStorage.getItem('scrollToHeaderAfterReload') === 'true') {
        sessionStorage.removeItem('scrollToHeaderAfterReload');
        $('html, body').animate({ scrollTop: 0 }, 250);
    }

    // Set active filter based on URL parameter
    var selectedCid = getParameterByName('cid');
    if (selectedCid) {
        $('.js-filters-btn-wrp a[data-category-id="' + selectedCid + '"]').addClass('cc-active');
    }

    // Handle category filter clicks
    $('.js-filters-btn-wrp a').on('click', function (e) {
        var $this = $(this);

        if ($this.hasClass('cc-active')) {
            e.preventDefault();
            $.spinner().start();
            var url = new URL(window.location.href);
            url.searchParams.delete('cid');
            window.location.href = url.toString();
        } else {
            $.spinner().start();
        }
    });

    /**
     * Initialize wishlist pagination
     */
    window.initWishlistPagination = function () {
        var $products = $('.js-wishlistProd');
        var totalProducts = $products.length;
        var totalPages = Math.ceil(totalProducts / CONSTANTS.PRODUCTS_PER_PAGE);
        var $pagesContainer = $('.cc-wishlist__pagination__pages');

        if (totalProducts === 0) return;

        var currentPage = 1;

        function renderPages(pages) {
            var pagesToRender = pages || totalPages;
            $pagesContainer.empty();

            var pagesArray = generatePagesArray(currentPage, pagesToRender, CONSTANTS.PAGE_RANGE);

            pagesArray.forEach(function (p) {
                if (p === '...') {
                    $pagesContainer.append('<span class="cc-wishlist__pagination__ellipsis"></span>');
                } else {
                    var activeClass = p === currentPage ? 'is-active' : '';
                    $pagesContainer.append('<button class="cc-wishlist__pagination__page ' + activeClass + '" data-page="' + p + '">' + p + '</button>');
                }
            });

            $('.js-prev').prop('disabled', currentPage === 1);
            $('.js-next').prop('disabled', currentPage === pagesToRender);
        }

        function showPage(page, pages, products) {
            var pagesToShow = pages || totalPages;
            var $productsList = products || $products;

            if (page < 1 || page > pagesToShow) return;

            currentPage = page;

            var start = (page - 1) * CONSTANTS.PRODUCTS_PER_PAGE;
            var end = start + CONSTANTS.PRODUCTS_PER_PAGE;

            $productsList.hide().slice(start, end).show();
            renderPages(pagesToShow);

            $('html, body').animate({ scrollTop: 0 }, CONSTANTS.SCROLL_DURATION);
        }

        showPage(1);

        $pagesContainer.off('click', '.cc-wishlist__pagination__page').on('click', '.cc-wishlist__pagination__page', function () {
            showPage($(this).data('page'));
        });

        $('.js-prev').off('click').on('click', function () {
            showPage(currentPage - 1);
        });

        $('.js-next').off('click').on('click', function () {
            showPage(currentPage + 1);
        });
    };

    window.initWishlistPagination();
});
